if (!customElements.get('plp-filters')) {
  class PlpFilters extends HTMLElement {
    constructor() {
      super();
    }
    
    close() {
      document.querySelector(`[data-drawer-action="open"][data-drawer-id="plp-mobile-filter-drawer"]`)?.focus();
      document.body.classList.remove('sparky-overlay');
      
      this.classList.add('sp-opacity-0', 'sp-translate-x-full')
      setTimeout(() => {
        this.classList.remove('sp-opacity-0', 'sp-translate-x-full')
      }, 500);
      

      setTimeout(() => {
        document.querySelector('.section-header')?.classList.replace('sp-z-[4]', 'sp-z-10');
        this.classList.add('sp-hidden');
        
        this.classList.remove('sp-top-0', 'sp-bottom-0', 'sp-left-0', 'sp-w-full', 'sp-h-full', 'sp-z-[1002]', 'sp-opacity-0', 'sp-transition-all', 'sp-duration-500');
        
      }, 500);
      
    }
    
    connectedCallback() {
      window.addEventListener('click', (e) => {
        if (e.target == this) {
          this.close();
        }
        
        const clickedElement = e.target.closest('[data-drawer-action]');
        if (!clickedElement) return;
        const {
          drawerAction,
        } = clickedElement.dataset;

        switch (drawerAction) {
          case 'open':    


            this.classList.remove('sp-hidden');
            document.querySelector('.section-header')?.classList.replace('sp-z-10', 'sp-z-[4]');
            setTimeout(() => {
              this.querySelectorAll('content-accordion').forEach((item) => item.setDefaultAccordions());
              document.body.classList.add('sparky-overlay');
              this.querySelector('[data-drawer-action="close"]')?.focus();
              
              this.classList.add('sp-top-0', 'sp-bottom-0', 'sp-left-0', 'sp-w-full', 'sp-h-full', 'sp-z-[1002]', 'sp-opacity-0');
            }, 10);
            this.classList.add('sp-translate-x-full', 'sp-transition-all', 'sp-duration-500');
            
            
            setTimeout(() => {

                  this.classList.remove('sp-opacity-0', 'sp-translate-x-full')

    
            }, 10);
          break;
          case 'close':
            this.close();
          break;
          default: break;
        }
      });
    }
  }
  
  customElements.define('plp-filters', PlpFilters);
}